import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, destructive } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	includeIntegrationsCheckbox: {
		color: 'black',
		fontSize: 14,
		fontWeight: 'bolder',
		margin: 20,
	},
	includeIntegrationsCheckboxContainer: {
		paddingLeft: 80,
	},
	resetAccountModal: {
		border: '2px solid #D0021B',
		borderRadius: 4,
		margin: '-22px',
		maxWidth: 380,
		padding: 20,
		paddingBottom: 30,
	},
	resetAccountModalBodyText1: {
		color: darkGrayFontColor,
		fontSize: 14,
	},
	resetAccountModalBodyText2: {
		color: darkGrayFontColor,
		fontSize: 14,
		paddingBottom: 20,
		paddingTop: 20,
	},
	resetAccountModalHeaderText: {
		color: destructive,
		fontSize: 18,
		paddingBottom: 20,
		paddingTop: 20,
	},
	resetAccountModalWarningText: {
		color: destructive,
		fontSize: 14,
	},
	resetAccountModalWarningText2: {
		color: destructive,
		fontSize: 14,
		marginTop: 0,
	},
	resetAccountModalCompanyName: {
		backgroundColor: '#FFF5F5',
		border: '1px solid #D0021B',
		borderRadius: 4,
		color: destructive,
		fontSize: 16,
		fontWeight: 700,
		marginBottom: 16,
		marginTop: 16,
		padding: 12,
		textAlign: 'center',
	},
});
